import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const totalValues = this.props.totalValues;
        const collectionCategoryReport = this.props.collectionCategoryReport

        return (
            <div>
                <h3><center><u>Rubber Collection Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division === undefined ? "All Divisions" : searchData.division}</div>
                    <div className="col"><b>Feild: </b> {searchData.feild === undefined ? "All Fields" : searchData.feild}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Emp.No</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Emp.Type</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Emp.Name</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Card Number</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>Card ReadTime</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>Total Litres</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>Metrolac Value</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>Dry Rubber Kilo</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {collectionCategoryReport.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell component="th" scope="row" align="left"> {row.epfNo}</TableCell>
                                    <TableCell component="th" scope="row" align="left"> {row.employeeTypeName}</TableCell>
                                    <TableCell component="th" scope="row" align="left"> {row.employeeName}</TableCell>
                                    <TableCell component="th" scope="row" align="right"> {row.cardNumber}</TableCell>
                                    <TableCell component="th" scope="row" align="right"> {moment(row.cardReadTime).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                                    <TableCell component="th" scope="row" align="right"> {row.totalLitres.toFixed(2)}</TableCell>
                                    <TableCell component="th" scope="row" align="right"> {row.metrolacValue.toFixed(2)}</TableCell>
                                    <TableCell component="th" scope="row" align="right"> {row.dryRubberKilo.toFixed(2)}</TableCell>
                                </TableRow>
                            )
                            )}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    <b>{totalValues.totalTotalLitres.toFixed(2)}</b></TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    <b>{totalValues.totalMetrolacValue.toFixed(2)}</b></TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                    <b>{totalValues.totalDryRubberKilo.toFixed(2)}</b></TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}